import { VideoCallView } from "../features/videocall/VideoCallView";

export const VideoCallPage = VideoCallView;
